import { useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@shared/contexts/auth-context";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireRole?: "user" | "superadmin";
}

// eslint-disable-next-line react/prop-types
export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requireRole = "user" }) => {
  const { user, isAuthenticated, isLoading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  // Отслеживаем разлогирование и редиректим
  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      navigate("/", { replace: true });
    }
  }, [isAuthenticated, isLoading, navigate]);

  if (isLoading) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  if (requireRole === "superadmin" && user?.role !== "superadmin") {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
